import { Box, Typography } from '@material-ui/core';
import { StandardDialog, ConfirmationButton, } from '@roc/ui';
import { observer } from 'mobx-react';
import { makeStyles } from '@material-ui/core/styles';
import { useEffect, useState } from 'react';
import { usePayoffRequestStore } from '@roc/feature-loans';
import RichTextEditor from '../utils/richTextEditor';


interface INotifyManagementApprovalDialogProps {
  loanId: number;
  open: boolean;
  onClose: () => void;
}

const useStyles = makeStyles(theme => ({

}));

export const NotifyManagementApprovalDialog = observer(({ loanId, open, onClose }: INotifyManagementApprovalDialogProps) => {
  const classes = useStyles();
  const { payoffRequestStore } = usePayoffRequestStore();
  const [texComment, setTexComment] = useState('')

  const notifyServicer = async () => {
    await payoffRequestStore.notifyManagementForPayoffApproval(loanId, payoffRequestStore.selectedPayoffId, texComment);
    await payoffRequestStore.getPayoffById(loanId, payoffRequestStore.selectedPayoffId);
    setTexComment('');
    onClose();
  }

  const getContent = () => {
    return (
      <Box display="flex" flexDirection="column" height="100%" width="100%">
        <Typography style={{ marginBottom: '10px' }} variant={"subtitle1"} >Comments:</Typography>
        <RichTextEditor
          value={texComment}
          onChange={(value) => setTexComment(value)}
        />
      </Box>
    )
  }

  return (
    <StandardDialog
      open={open}
      title={"Management Approval Needed"}
      maxWidth="sm"
      handleClose={onClose}
      dialogContent={
        getContent()
      }
      dialogActions={(
        <>
          <Box mr={2}>

            <ConfirmationButton
              onClick={notifyServicer}
              color="primary"
              variant="contained"
              testId="confirm"
              confirmDialogProps={{
                title: 'Confirmation',
                body:
                  'Are you sure you want to send this management approval notification?',
              }}
            >
              Notify Management
            </ConfirmationButton>
          </Box>
        </>
      )}
    />
  );
});